export default "__VITE_ASSET__25707d85__"